import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button } from "@material-ui/core";
import { Add } from '@material-ui/icons';
import ICommonFormProps from '../../../../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps';
import { useStyles } from "../styles"
import { IReduxAppState } from '../../../../../reducers';
import { SelectedItemsList } from './SelectedItemsList';
import { SelectedItemsReOrderingList } from "./SelectedItemsReOrderingList"
import { ADD_ITEM, dialogKeys } from '../../../../../const/URL.const';
import FormElement from '../../../../../yoello-lib/modules/dynamicForms/FormElement';
import DisabledActionWrapper from '../../../../../yoello-lib/modules/components/DisabledActionWrapper';
import useCheckPermissions from '../../../../../hooks/useCheckPermissions';
import { PERMISSIONS } from '../../../../../const/permissions.const';

export function AddItemsButton(props: ICommonFormProps) {
  const classes = useStyles();
  const isEposNow = useSelector((state: IReduxAppState) => state.isEposNow);

  const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.MENU_MANAGEMENT);

  useEffect(() => {
    if (props.setValue) {
      let value: string[] = []
      if (Array.isArray(props?.formProps?.itemsList)) {
        value = props?.formProps?.itemsList.map((obj) => obj.id)!;
      }
      // const value
      props.setValue(props.keyName, value, { shouldDirty: true });
    }
    //eslint-disable-next-line
  }, [props.formProps?.itemsList]);

  const { t } = useTranslation();
  const renderSecondLabel = () => {
    if (props?.formProps?.itemsList?.length > 0) {
      return <p className={classes.selectedItemsText}> <span data-component-name="SELECTED_ITEMS_COUNT"> {props?.formProps?.itemsList.length}</span> {props?.formProps?.selectedItemsText}</p>
    }
    return <p>{props.formProps?.secondLabel}</p>

  }
  const renderList = () => {

    if (props.formProps) {
      const { itemsList, useReOrderingList } = props.formProps;
      if (!props.disabled && useReOrderingList) {
        return <SelectedItemsReOrderingList
          fieldList={props!.formProps!.fieldList}
          listClassName={classes.reOrderingListContainer}
          listItems={props!.formProps!.itemsList}
          dataComponentName={props!.formProps!.dataComponentName}
          onSortedItem={props!.formProps!.onSortItems}
        />
      } else if (itemsList && itemsList.length > 0) {
        return <SelectedItemsList disableButton={props.disabled || (!props?.formProps?.isMenus && isEposNow)} itemsList={itemsList} fieldList={props!.formProps!.fieldList} onDelete={props?.formProps?.onDeleteSelectedItem} />
      }
    }
  }

  return (
    <FormElement {...props}>
      <div className={classes.addExtrasContainer}>
        <label htmlFor="">{props.label}</label>
        <div>
          <div>
            {
              renderSecondLabel()
            }
            {(!isEposNow || props?.formProps?.isMenus) &&
              <DisabledActionWrapper
                disabled={!hasPermission}
                onDisabledClick={onFailedInteraction}

              >
                <Button
                  data-component-name={"EXTENDER_BUTTON"}
                  onClick={() => {
                    const prevData = { ...props.getValues!() }
                    const itemData = props?.formProps?.getProps(props.formProps.prevModal, props?.formProps?.formDataKey);
                    props?.formProps?.setProps(props.formProps.prevModal, props?.formProps?.formDataKey, { ...itemData, ...prevData });
                    props.formProps?.goToNextStep(dialogKeys.ASSIGNITEM, {
                      ComponentProps: {
                        ...props?.formProps?.dialogProps,
                        formData: props?.formProps?.formData ? props.formProps.formData : {},
                        isNewItem: props?.formProps?.formData ? false : true,
                        selectedItems: props?.formProps?.itemsList ?? []
                      },
                      isFormDialog: true,
                      dialogTitle: t(props?.formProps?.dialogTitle),
                    }, `${props.formProps?.parentPath}/${props.formProps?.id}${ADD_ITEM}`, props.formProps?.prevModal ?? null)
                  }}
                  disabled={props.disabled}
                  variant="outlined"
                  style={
                    props.disabled ? {} :
                      { color: "#212121", borderColor: "#C1CAE1!important" }
                  }> <Add style={{ paddingRight: "0.625rem", fontSize: "2rem" }} /> {props?.formProps?.itemsList?.length > 0 ? t("misc.AddRemoveItems") : t("misc.AddItems")}
                </Button>
              </ DisabledActionWrapper>
            }
          </div>
          {renderList()}
        </div>

      </div>
    </FormElement >
  )
}
